import React from 'react';
import { Button } from 'react-bootstrap';
import {Trash3 } from 'react-bootstrap-icons';

const DeleteButtonCellRender = ({ data, onDelete }) => {
  const handleDelete = () => {
    onDelete(data._id);
  };

  return (
    <button className='tableButton' onClick={handleDelete}><Trash3 /></button>
  );
};

export default DeleteButtonCellRender;